import styled from "styled-components";
import IconArrow from '../../assets/images/icon-prev.svg'
import IconClose from '../../assets/images/icon-close-2.svg'

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    position: relative;
`;

const Header = styled.div`
    width: 100%;
    height: 50px;
    max-width: 768px;
    position: fixed;
    top: 0px;
    z-index: 999;
    background-color: #FFFFFF;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    justify-content: space-between;

    .btn-header {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;

        &.hide {
            cursor: default;
        }
    }

`;

const Body = styled.div`
    width: 100%;
    max-width: 768px;
    height: calc(100% - 50px);
    position: absolute;
    top: 50px;
    background-color: #FFFFFF;
`;

function EvaluatorLayout({
    children,
    showBack,
    showClose,
    onClickBack,
    onClickClose,
}) {
    function handleClickBack() {
        if (!showBack) return
        onClickBack && onClickBack();
    }
    function handleClickClose() {
        if (!showClose) return
        onClickClose && onClickClose();
    }

    return (
        <Container id="main-container-layout">
            <Header className="vertical-center">
                <div className={`content-center btn-header ${showBack ? "" : "hide"}`} onClick={handleClickBack}>
                    {showBack &&
                        <img alt="img" src={IconArrow} style={{ width: "30px" }} />
                    }
                </div>

                <div>การกีฬาแห่งประเทศไทย</div>
                <div className={`content-center btn-header ${showClose ? "" : "hide"}`} onClick={handleClickClose}>
                    {showClose &&
                        <img alt="img" src={IconClose} style={{ width: "16px" }} />
                    }
                </div>
            </Header>
            <Body>
                {children}
            </Body>
        </Container>
    )
}

export default EvaluatorLayout;